export default {
	setLoginIdentity: (state, val) => {
		state.identity = val
	},
	setLoginAccount: (state, val) => {
		state.account = val
	},
	setAccountBalance: (state, val) => {
		state.balance = val
	}
}
